export class AlexFeedbackModel {
    sessionId: string;
    feedback: string;
    agentResponseMsg: string;
    isPositive: boolean;
}

